import React, { useState, useRef, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { languages } from './config/languageConfig';
import { useNavigate } from 'react-router-dom';

const LanguageSelector = ({ currentLanguage, onLanguageChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentLang = languages.find(lang => lang.code === currentLanguage);

  const handleLanguageChange = (newLanguage) => {
    const pathSegments = window.location.pathname.split('/').filter(segment => segment !== '');
    console.log('Current path segments:', pathSegments);

    if (languages.some(lang => lang.code === pathSegments[pathSegments.length - 1])) {
      pathSegments[pathSegments.length - 1] = newLanguage;
    } else if (pathSegments.length === 1) {
      pathSegments.push(newLanguage);
    } else {
      pathSegments[pathSegments.length - 1] = newLanguage;
    }

    const newPath = pathSegments.join('/');
    console.log('New path:', newPath);
    navigate(newPath);
    localStorage.setItem('userLanguage', newLanguage);
    if (typeof onLanguageChange === 'function') {
      onLanguageChange(newLanguage);
    } else {
      console.warn('onLanguageChange is not a function');
    }
    
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors rounded-lg hover:bg-slate-100"
      >
        <Globe className="w-4 h-4 mr-2" />
        <span className="mr-1">{currentLang?.flag}</span>
        <span>{currentLang?.code.toUpperCase()}</span>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center space-x-2
                ${currentLanguage === language.code ? 'bg-slate-50 text-blue-600' : 'text-slate-700'}`}
            >
              <span className="text-base">{language.flag}</span>
              <span>{language.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;